function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M21.998 40.87l18.33 31.659c.665 1.15-.167 2.587-1.498 2.587H2.17C.84 75.116.008 73.68.673 72.53l18.33-31.658c.666-1.15 2.33-1.15 2.996 0z",
  fill: "#FF7D13"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.5 39.892c11.08 0 20.062-8.93 20.062-19.946C40.562 8.93 31.58 0 20.5 0 9.42 0 .438 8.93.438 19.946c0 11.016 8.982 19.946 20.062 19.946z",
  fill: "#0AC700"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M116.998 40.87l18.33 31.659c.665 1.15-.167 2.587-1.498 2.587H97.17c-1.33 0-2.163-1.437-1.498-2.587l18.33-31.658c.666-1.15 2.33-1.15 2.996 0z",
  fill: "#FF7D13"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M115.5 39.892c11.08 0 20.062-8.93 20.062-19.946C135.562 8.93 126.58 0 115.5 0c-11.08 0-20.061 8.93-20.061 19.946 0 11.016 8.981 19.946 20.061 19.946zM69.015 55.14l10.692 18.467c.389.671-.097 1.51-.874 1.51H57.45a1.006 1.006 0 01-.874-1.51L67.267 55.14a1.01 1.01 0 011.748 0z",
  fill: "#0AC700"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M68.141 54.569c6.463 0 11.703-5.21 11.703-11.636 0-6.425-5.24-11.634-11.703-11.634-6.463 0-11.703 5.209-11.703 11.635 0 6.425 5.24 11.635 11.703 11.635z",
  fill: "#FF7D13"
});

function SvgGroup1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 136 76",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default SvgGroup1;